import api, { getPaginatedList } from 'shared/api'

export const doLoad = async props => {
  return await getPaginatedList('/admin/answers', {
    ...props,
  })
}

export const doDelete = async ({ id }) => {
  await api.delete(`/admin/answers/${id}`)
}
